import loadable from '@loadable/component';
import React, { FunctionComponent } from 'react';

const LazyReportThisEvent = loadable.lib(
    () => import('@eventbrite/report-this-event'),
);

interface ReportThisEventProps {
    domNodeId: string;
    onClose: () => void;
    isVisible: boolean;
    eventId: string;
}

export const ReportThisEventController: React.FunctionComponent<{
    isReportThisEventVisible: boolean;
    setIsReportThisEventVisible: Function;
    event: { id: string };
}> = (props) => {
    const { isReportThisEventVisible, setIsReportThisEventVisible, event } =
        props;

    return (
        <>
            {isReportThisEventVisible && (
                <LazyReportThisEvent>
                    {({
                        ReportThisEvent,
                    }: {
                        ReportThisEvent: FunctionComponent<ReportThisEventProps>;
                    }) => (
                        <ReportThisEvent
                            domNodeId="listings-root"
                            eventId={event.id}
                            onClose={() => setIsReportThisEventVisible(false)}
                            isVisible={isReportThisEventVisible}
                        />
                    )}
                </LazyReportThisEvent>
            )}
        </>
    );
};
